module.exports = __webpack_public_path__ + "img/1560881086.0b7022e7.jpg";